import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "detail cf pdg",
  "data-pdgb": "80"
}
const _hoisted_3 = { class: "cart" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "product" }
const _hoisted_8 = { class: "qty" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = { class: "rows" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "product cf" }
const _hoisted_14 = {
  key: 0,
  class: "image"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "variant" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "cod" }
const _hoisted_22 = { class: "qty" }
const _hoisted_23 = { class: "price" }
const _hoisted_24 = { class: "unit" }
const _hoisted_25 = { class: "total" }
const _hoisted_26 = { class: "unit" }
const _hoisted_27 = {
  class: "calltoaction mrg",
  "data-mrgt": "20",
  "data-color": "greyl"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "input" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  class: "calltoaction",
  "data-color": "greyl"
}
const _hoisted_33 = {
  key: 1,
  class: "button disable-on-submit"
}
const _hoisted_34 = { class: "note" }
const _hoisted_35 = {
  key: 0,
  class: "discount"
}
const _hoisted_36 = { class: "description" }
const _hoisted_37 = {
  key: 0,
  class: "total"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "unit" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 1,
  class: "alert"
}
const _hoisted_42 = { class: "footer" }
const _hoisted_43 = { class: "data" }
const _hoisted_44 = {
  key: 0,
  class: "shipping"
}
const _hoisted_45 = {
  key: 0,
  class: "shipping-cost"
}
const _hoisted_46 = {
  key: 1,
  class: "shipping-cost",
  "data-free": "true"
}
const _hoisted_47 = {
  key: 1,
  class: "shipping",
  "data-type": "note"
}
const _hoisted_48 = ["href"]
const _hoisted_49 = {
  key: 2,
  class: "shipping",
  "data-type": "note"
}
const _hoisted_50 = { class: "total" }
const _hoisted_51 = { class: "unit" }
const _hoisted_52 = {
  id: "CartTotal",
  class: "value"
}
const _hoisted_53 = {
  key: 3,
  class: "minimumtotal"
}
const _hoisted_54 = {
  key: 4,
  class: "minimumtotalgap"
}
const _hoisted_55 = { class: "payment-method form" }
const _hoisted_56 = { class: "control" }
const _hoisted_57 = { class: "label" }
const _hoisted_58 = { value: "PayPal" }
const _hoisted_59 = { value: "BankTransfer" }
const _hoisted_60 = {
  class: "disclaimer mrg",
  "data-mrgt": "10"
}
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = {
  class: "calltoaction",
  "data-size": "big"
}
const _hoisted_63 = {
  key: 1,
  class: "button disable-on-submit"
}
const _hoisted_64 = { class: "valid-summary" }
const _hoisted_65 = {
  key: 1,
  class: "detail cf pdg",
  "data-pdgb": "80"
}
const _hoisted_66 = { class: "title" }
const _hoisted_67 = {
  class: "subtitle mrg",
  "data-mrgt": "20",
  "data-line": "false"
}
const _hoisted_68 = {
  class: "mrg",
  "data-mrgt": "40"
}
const _hoisted_69 = ["innerHTML"]

import { ref, computed, onUpdated, nextTick } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutSummary',
  setup(__props) {

const store = useStore();

const localizer = Localizer;
const routes = (window as any).App.routes;

const validationErrors = ref<any[]>([]);
const isLoadingForm = ref(false);
const isTermsApproved = ref(false);
const isGAEventSent = ref(false);
const couponCode = ref<string>(null);
const paymentMethod = ref<string>("PayPal");

const cart = computed(() => {
    let cartData = store.getters["cartStore/cart"];

    couponCode.value = cartData ? cartData.couponCode : null;

    paymentMethod.value = cartData ? cartData.paymentMethod : "PayPal";
    return cartData;
});

async function setCouponCode() {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_SetCouponCode, { couponCode: couponCode.value })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

async function setPaymentMethod() {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        let response = (await Axios.post(routes.Cart_SetPaymentMethod, { paymentMethod: paymentMethod.value })).data;

        store.commit("cartStore/setCart", response.cartInfo);
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

function formatPrice(data: string) {
    return Number(data).toFixed(2).replace(".", ",");
}

async function placeOrder() {
    FormHelper.removeFocus();

    isLoadingForm.value = true;

    validationErrors.value = [];

    try {
        const response = (await Axios.post(routes.Checkout_Summary)).data;

        window.location = response.redirectUrl;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

onUpdated(() => {
    nextTick(() => {
        if (cart.value && !isGAEventSent.value) {
            var itemList = [];

            for (var cartRow in cart.value.cartRows) {
                itemList.push({
                    item_id: cart.value.cartRows[cartRow].productCode,
                    item_name: cart.value.cartRows[cartRow].productTitle,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: cart.value.cartRows[cartRow].categoryName,
                    price: parseFloat(cart.value.cartRows[cartRow].unitPrice.replace(',', '.')),
                    quantity: cart.value.cartRows[cartRow].quantity
                });
            }

            GTagHelper.sendCustomEvent("begin_checkout", {
                currency: "EUR",
                value: parseFloat(cart.value.cartTotalWithCosts.replace(',', '.')),
                coupon: cart.value.CouponCode,
                items: itemList
            });

            isGAEventSent.value = true;
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (cart.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (cart.value.cartQuantity !== 0)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("table", _hoisted_4, [
                    _createElementVNode("thead", _hoisted_5, [
                      _createElementVNode("tr", _hoisted_6, [
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(localizer).get("Checkout.Common.ProductDescription")), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(localizer).get("Checkout.Common.Quantity")), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(localizer).get("Checkout.Common.Price")), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(localizer).get("Checkout.Common.Total")), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.cartRows, (cartRow) => {
                      return (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                        _createElementVNode("tr", _hoisted_12, [
                          _createElementVNode("td", _hoisted_13, [
                            (cartRow.productImageUrl)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("a", {
                                    href: cartRow.productUrl
                                  }, [
                                    _createElementVNode("img", {
                                      src: cartRow.productImageUrl,
                                      width: "100",
                                      height: "100",
                                      alt: "",
                                      loading: "lazy"
                                    }, null, 8, _hoisted_16)
                                  ], 8, _hoisted_15)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("a", {
                                href: cartRow.productUrl,
                                class: "title"
                              }, _toDisplayString(cartRow.productTitle), 9, _hoisted_18),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(cartRow.variantTitle), 1),
                                _createTextVNode(_toDisplayString(cartRow.variantDescription), 1)
                              ]),
                              _createElementVNode("div", _hoisted_21, "cod. " + _toDisplayString(cartRow.productCode), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_22, _toDisplayString(cartRow.quantity), 1),
                          _createElementVNode("td", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                            _createTextVNode(_toDisplayString(cartRow.unitPrice), 1)
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                            _createTextVNode(_toDisplayString(cartRow.rowPrice), 1)
                          ])
                        ])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      href: _unref(routes).Cart_Detail,
                      class: "button"
                    }, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.EditCart")), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon zmdi zmdi-edit" }, null, -1))
                    ], 8, _hoisted_28)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["coupon", { active: cart.value.isCoupon }])
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event)),
                          id: "CouponCode",
                          name: "CouponCode",
                          type: "text",
                          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (setCouponCode()), ["prevent","stop"]), ["enter"])),
                          placeholder: _unref(localizer).get('Checkout.Common.InsertCoupon'),
                          class: "input textbox disable-on-submit",
                          maxlength: "50"
                        }, null, 40, _hoisted_31), [
                          [
                            _vModelText,
                            couponCode.value,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        (!isLoadingForm.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "button disable-on-submit",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (setCouponCode()))
                            }, _toDisplayString(_unref(localizer).get("Checkout.Common.Apply")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(localizer).get("Checkout.Common.Apply")), 1))
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("em", null, _toDisplayString(_unref(localizer).get("Checkout.Common.CouponDisclaimer")), 1)
                      ])
                    ]),
                    (cart.value.isCoupon)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("em", null, _toDisplayString(cart.value.couponDescription), 1)
                          ]),
                          (cart.value.couponDiscount !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                (cart.value.couponDiscountMode === 'Amount')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                                      _createTextVNode("-" + _toDisplayString(formatPrice(cart.value.couponDiscount)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (cart.value.couponDiscountMode === 'Percentage')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                      _createTextVNode(" -" + _toDisplayString(cart.value.couponDiscount), 1),
                                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "unit" }, "%", -1))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (cart.value.couponMinimumCartTotal && cart.value.couponMinimumGap !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_Start")) + " " + _toDisplayString(formatPrice(cart.value.couponMinimumGap)) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.CouponGap_End")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      (cart.value.shippingMode != 'ExWork')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (!cart.value.isFreeShippingCosts)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(localizer).get("Checkout.Common.Shipping")) + ": " + _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")) + " " + _toDisplayString(cart.value.shippingCosts), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(localizer).get("Checkout.Common.FreeShipping")), 1))
                          ]))
                        : (cart.value.shippingMode == 'ExWork')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.Shipping_ExWork_Note")) + " ", 1),
                              _createElementVNode("a", {
                                href: _unref(routes).Support_ShippingReturns + '#ExWorks',
                                class: "link"
                              }, _toDisplayString(_unref(localizer).get("App.Common.ShippingExWork_More")), 9, _hoisted_48)
                            ]))
                          : (cart.value.shippingMode == 'WarehousePickup')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(localizer).get("Checkout.Common.Shipping_WarehousePickup_Note")), 1))
                            : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        (cart.value.shippingMode != 'ExWork')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.TotalIvaShipping")), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_unref(localizer).get("Checkout.Common.TotalIva")), 1)
                            ], 64)),
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(cart.value.cartTotalWithCosts), 1)
                      ]),
                      (cart.value.minimumTotalGap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotal")) + " " + _toDisplayString(cart.value.minimumOrderTotal), 1))
                        : _createCommentVNode("", true),
                      (cart.value.minimumTotalGap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_Start")) + " " + _toDisplayString(cart.value.minimumTotalGap) + " " + _toDisplayString(_unref(localizer).get("Checkout.Common.MinimumTotalGap_End")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(localizer).get("Checkout.Common.PaymentMethod")), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "dropdown",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentMethod).value = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (setPaymentMethod()))
                          }, [
                            _createElementVNode("option", _hoisted_58, _toDisplayString(_unref(localizer).get("Checkout.Common.PayPal")), 1),
                            _createElementVNode("option", _hoisted_59, _toDisplayString(_unref(localizer).get("Checkout.Common.BankTransfer")), 1)
                          ], 544), [
                            [
                              _vModelSelect,
                              paymentMethod.value,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", {
                          innerHTML: _unref(localizer).get('Checkout.Common.ConfirmTermsOfSale', _unref(routes).Terms_TermsOfSale, _unref(localizer).get('Checkout.Common.ConfirmTermsOfSale_Button'))
                        }, null, 8, _hoisted_61)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        (!isLoadingForm.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "button disable-on-submit",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (placeOrder()))
                            }, _toDisplayString(_unref(localizer).get("Checkout.Common.BuyNow")), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_unref(localizer).get("Checkout.Common.BuyNow")), 1))
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("div", null, _toDisplayString(validationError.message), 1))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(localizer).get("Checkout.Common.CheckoutError_Title")), 1),
                _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(localizer).get("Checkout.Common.CheckoutError_Abstract")), 1),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("span", {
                    innerHTML: _unref(localizer).get('Checkout.Common.CheckoutError_Description', _unref(routes).Support_Contact, _unref(localizer).get('Checkout.Common.CheckoutError_Description_Link'))
                  }, null, 8, _hoisted_69)
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})